import { serverConfig } from "./serverConstants";

export const WEB_URL = "https://www.assesshub.co.in/";
export const PRIVACY_POLICY_WEB_URL = "https://www.assesshub.com/privacy-policy/";
export const SUPPORT_MAIL = "support@assesshub.com";

export const answersBaseURL = serverConfig.answersBaseURL;
export const resultBaseURL = serverConfig.resultBaseURL;
export const proctoringURL = serverConfig.proctoringURL;
export const adminBackendURL = serverConfig.adminBackendURL;

// Secure cookie options for all Cookies.set() calls
const hostname = window.location.hostname;
const isSecure = window.location.protocol === "https:";
const isAssessHub = hostname.includes("assesshub.com");
const isStaging = hostname.includes("staging") || hostname.includes("myassesshub");
export const COOKIE_OPTIONS = {
  path: "/",
  secure: isSecure,
  sameSite: "Lax",
  ...(isAssessHub && !isStaging && { domain: ".assesshub.com" }),
  expires: 0.5
};